/**
 * Created by andrey on 18.08.2025
 */

const Map2dPool = function (map2d) {
    this.map2d = map2d;

    this.data = {};
    this.size = 0;
};

Map2dPool.prototype.add = function (x, y, obj = true) {
    if (!this.data[y]) {
        this.data[y] = {};
    }

    if (this.data[y][x]) {
        cleverapps.throwAsync(`Map2dPool.add: cell ${x},${y} already exists, overwriting`);
    } else {
        this.size++;
    }

    this.data[y][x] = obj || true;
};

Map2dPool.prototype.remove = function (x, y) {
    if (this.data[y] && this.data[y][x]) {
        delete this.data[y][x];
        this.size--;

        // eslint-disable-next-line no-unreachable-loop
        for (const i in this.data[y]) {
            return;
        }

        delete this.data[y];
    }
};

Map2dPool.prototype.has = function (x, y) {
    return Boolean(this.data[y] && this.data[y][x]);
};

Map2dPool.prototype.get = function (x, y) {
    return this.data[y] && this.data[y][x];
};
